const normalizePhones = ({ phones, phone }) => {
  const items = []

  const addParsedString = (str) => {
    return str
      .split('/')
      .map(part => part.trim())
      .filter(Boolean)
      .map(part => ({ value: part, label: part }))
  }

  if (typeof phone === 'string') {
    items.push(...addParsedString(phone))
  }

  if (typeof phones === 'string') {
    items.push(...addParsedString(phones))
  }

  if (Array.isArray(phones)) {
    for (const item of phones) {
      if (typeof item === 'string') {
        items.push(...addParsedString(item))
      } else if (typeof item === 'object' && item !== null) {
        const value = item.value || item.label
        const label = item.label || item.value
        if (value) {
          items.push({ value, label })
        }
      } else if (item != null) {
        // Bug real (auditoría 2026-08-16): un item que no fuera string ni
        // objeto (ej. un number/boolean, dato legacy/importado sin migrar)
        // no matcheaba ninguna rama de arriba y se descartaba en silencio —
        // un teléfono real desaparecía de la UI sin ningún indicio de que
        // existía.
        items.push(...addParsedString(String(item)))
      }
    }
  }

  // Eliminar duplicados por `value`
  const seen = new Set()
  const result = []

  for (const item of items) {
    const val = String(item.value).trim().replace(/\D/g, '')
    if (!val || seen.has(val)) continue
    seen.add(val)
    result.push({ value: val, label: item.label || val })
  }

  return result
}

export default normalizePhones
